module ProcessList {
    import IModalInstance = angular.ui.bootstrap.IModalServiceInstance;
    import AllEnvironmentNames = Shared.Environments.IAllEnvironmentNames;

    export class DeleteProcessModalController {
        public willCascadeDelete: boolean;
        public isDefaultEnv: boolean;

        static $inject = ["processes", "$uibModalInstance", "currentEnvironmentName", "currentAgentGroupName", "allEnvironmentNames", "notifications", "ProcessDataService"];
        constructor(
            public processes: IProcessData[],
            private $modalInstance: IModalInstance,
            private currentEnvironmentName: string,
            private currentAgentGroupName: string,
            private allEnvironmentNames: AllEnvironmentNames[],
            private notifications: INotifications,
            private processDataService: ProcessDataService) {
   
            this.willCascadeDelete = _.some(processes, proc => proc.existingVersions.some(existArr => existArr.deployedProcessVersions.some(values => values.environmentName !== EnvironmentVariables.DEFAULT_ENV_NAME)));
            this.isDefaultEnv = currentEnvironmentName === EnvironmentVariables.DEFAULT_ENV_NAME;
        }

        private getEnvironmentName(sourceEnvironmentName) : string {
            return _.find(this.allEnvironmentNames, x => x.name === sourceEnvironmentName).displayName;
        }

        public confirm() {
            this.processDataService.deleteProcesses(_.map(this.processes, p => p.id), this.currentEnvironmentName, this.currentAgentGroupName)
                .then(response => {
                    if (response && response.success) {
                        this.notifications.notify(response.data);
                        this.$modalInstance.close();
                    }
                });
        };

        public cancel() {
            this.$modalInstance.dismiss();
        }
    }

    module.controller("DeleteProcessModalController", DeleteProcessModalController);
}